import { render } from "./MyTicketsTest.vue?vue&type=template&id=3800d119&scoped=true"
import script from "./MyTicketsTest.vue?vue&type=script&lang=js"
export * from "./MyTicketsTest.vue?vue&type=script&lang=js"

import "./MyTicketsTest.vue?vue&type=style&index=0&id=3800d119&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3800d119"

export default script